import type { BookingContext } from './booking-context';

export function showLoadingOverlay(context: BookingContext) {
	context.root.setAttribute('data-loading', '');
}

export function hideLoadingOverlay(context: BookingContext) {
	context.root.removeAttribute('data-loading');
}
